<template>
  <div class="main">
    <div class="mainContent">
      <div class="mainDetailsBox boldShow marL">
        <div class="l mainLeft">
          <div class="contTitle" style="padding:12px 20px;border-top-right-radius:0">
            <label class="titleLeft marR30"><b>Order No：</b>{{OrderInfo.Id}}</label>
          </div>
          <div class="content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="News" name="first">
                <div class="padPX" style="padding:0 15px 0 0">
                  <iframe id="openIframe" :src="SrcFrom(OrderInfo.Id)" frameborder="no" style="width:103%;height:900px;"></iframe>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Shipment Details" name="second">
                <div class="padPX">
                  <table border="0" cellspacing="0" cellpadding="0" width="100%" class="detailsTableGray">
                    <tr>
                      <th colspan="3" align="left">Booking info.</th>
                    </tr>
                    <tr>
                      <td width="30%"><span class="marR20">Type of shipping: {{OrderInfo.ModeCode}}</span></td>
                      <td width="26%"><span class="marR20">Package type: {{PackageTypeName(OrderInfo.PackageType)}}</span></td>
                      <td>Commodity: {{OrderInfo.CargoDescsEn}}</td>
                    </tr>
                    <tr>
                      <td colspan="3">Note:{{OrderInfo.Remark}}<span v-if="OrderInfo.InsideBattery||OrderInfo.InsideBattery!=0">
                          <!-- 包含电池： -->
                          {{InsideBatteryName(OrderInfo.InsideBattery)}}</span><span v-if="OrderInfo.MatingBattery||OrderInfo.MatingBattery!=0">
                          <!-- 包含电池： -->
                          {{MatingBatteryName(OrderInfo.MatingBattery)}}</span></td>
                    </tr>
                    <tr>
                      <td colspan="3">Insurance:
                        <span v-if="OredrInsurance.BuyAmount">Insurance amount: {{OredrInsurance.BuyAmount.toFixed(2)}}USD</span>
                        <span class="marL30" v-if="OredrInsurance.BenefitType==1">Insured beneficiary company: {{OredrInsurance.Beneficiary}}</span>
                      </td>
                    </tr>
                  </table>
                  <table border="0" cellspacing="0" cellpadding="0" width="100%" class="detailsTableGray marTop20" style="border-top:1px solid #eee;" v-if="ShowProBox">
                    <tr>
                      <th align="left" style="padding-top:10px;"><a @click="clkProInfos">Product info. <i class="fa fa-arrDown colGray9" :class="isShowProInfo?'tranForm180':''"></i></a></th>
                    </tr>
                    <tr v-show="isShowProInfo">
                      <td>
                        <table border="0" cellspacing="0" cellpadding="0" width="100%" class="tableGrayLine tableBor marTop10">
                          <tr>
                            <th align="center" width="30%">Commodity</th>
                            <th align="center" width="25%">Material</th>
                            <th align="center" width="25%">Use</th>
                            <th align="center">HS Code</th>
                          </tr>
                          <tr v-for="(item,index) in ProductList" :key="index" v-show="ProductList.length > 0">
                            <td align="center">{{item.EnglishName}}</td>
                            <td align="center">{{item.Material}}</td>
                            <td align="center">{{item.Purpose}}</td>
                            <td align="center">{{item.HSCode}}</td>
                          </tr>
                          <tr v-show="ProductList.length <= 0">
                            <td colspan="4" align="center">No results</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <table border="0" cellspacing="0" cellpadding="0" width="100%" class="detailsTableGray marTop20" style="border-top:1px solid #eee;">
                    <tr>
                      <th colspan="5" align="left" style="padding-top:10px;">Receiving info.</th>
                    </tr>
                    <tr>
                      <td colspan="5" align="left" v-if="OrderInfo.PackageType==1">Cargo Totals</td>
                    </tr>
                    <!-- <tr><td colspan="5" align="left" v-if="OrderInfo.PackageType==2">Chargeable weight: {{SumCargoCusChargeWeight.toFixed(3)}} KG</td></tr> -->
                    <tr>
                      <td colspan="5" align="left" v-if="OrderInfo.PackageType==2 && Receivinginfo.ReceCusChargeWeight > 0">Chargeable weight: {{(Receivinginfo.ReceCusChargeWeight).toFixed(3)}} KG</td>
                    </tr>
                    <tbody v-if="OrderInfo.PackageType==1 && OrderGoodsInfo.length>0">
                      <tr class="tdBorLine">
                        <td width="20%"><b>Total unit</b></td>
                        <td width="20%"><b>Total weight</b></td>
                        <td width="20%"><b>Total volume</b></td>
                        <td width="20%"><b>Volume weight</b></td>
                        <td><b>Chargeable weight</b></td>
                      </tr>
                      <tr class="tdBorLine">
                        <td>{{Receivinginfo.ReceCount}}</td>
                        <td>{{(Receivinginfo.ReceWeight).toFixed(3)}} KG</td>
                        <td>{{(Receivinginfo.ReceVolume).toFixed(4)}} CBM</td>
                        <td>{{(Receivinginfo.ReceCusVolWeight).toFixed(3)}} KG</td>
                        <td>{{(Receivinginfo.ReceCusChargeWeight).toFixed(3)}} KG</td>
                      </tr>
                    </tbody>
                  </table>
                  <table border="0" cellspacing="0" cellpadding="0" width="100%" class="detailsTableGray marTop20 " style="border-top:1px solid #eee;" v-if="OrderInfo.PackageType==1">
                    <tr>
                      <th colspan="6" align="left" style="padding:10px 0">Shipped cargo details <i class="fa fa-arrDown colGray9" style="cursor:pointer;" @click="Warehouse()" :class="IsWarehouse ? 'tranForm180' : ''"></i></th>
                    </tr>
                    <tbody v-if="IsWarehouse">
                      <tr class="tdBorLine">
                        <td width="5%"><b>No.</b></td>
                        <td width="14%"><b>Total cartons</b></td>
                        <td width="10%">
                          <p><b>Weight</b></p>
                          <p><b>(KG)</b></p>
                        </td>
                        <td width="25%">
                          <p><b>Length × Width × Height</b></p>
                          <p><b>（CM）</b></p>
                        </td>
                        <td width="10%">
                          <p><b>Volume</b></p>
                          <p><b>(CBM)</b></p>
                        </td>
                        <td width="15%">
                          <p><b>Volume weight</b></p>
                          <p><b>(KG)</b></p>
                        </td>
                        <td>
                          <p><b>Chargeable weight/</b></p>
                          <p><b>Chargeable volume</b></p>
                        </td>
                      </tr>
                      <tr class="tdBorLine" v-for="(item,index) in OrderGoodsInfo" :key="index" v-if="OrderGoodsInfo.length>0">
                        <td>{{index+1}}</td>
                        <td>{{item.Quanlity}}</td>
                        <td>{{(item.Weight).toFixed(3)}}</td>
                        <td>{{(item.Long).toFixed(3)}} × {{(item.Wide).toFixed(3)}} × {{(item.Height).toFixed(3)}}</td>
                        <td>{{item.Volume}}</td>
                        <td>{{(item.CusVolWeight).toFixed(3)}}</td>
                        <td>{{(item.CusChargeWeight).toFixed(3)}}</td>
                      </tr>
                      <tr v-if="OrderGoodsInfo.length<=0" class="tdBorLine">
                        <td colspan="7" align="center">No results</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Documents" name="third">
                <div class="padPX">
                  <table border="0" cellspacing="0" cellpadding="0" width="100%" class="tableGrayBotLine">
                    <tr>
                      <th align="left" width="35%">The file name</th>
                      <th align="left" width="25%">Upload time</th>
                      <th align="left" width="25%">Uploader</th>
                      <th></th>
                    </tr>
                    <tr v-for="(item,index) in OrderEnclosure" :key="index" v-if="OrderEnclosure.length > 0">
                      <td>{{item.BuildFileName}}</td>
                      <td>{{ new Date(item.CreateTime).Format('yyyy-MM-dd hh:mm:ss')||''}}</td>
                      <td>{{item.CreateName}}</td>
                      <td align="center">
                        <a><i class="fa fa-dowIcon colBlue" style="font-size:18px;" @click="DownloadAttachments(item.FIlePath,item.OriginaFilelName)"></i></a>
                      </td>
                    </tr>
                    <tr v-if="OrderEnclosure.length <= 0">
                      <td colspan="4" align="center" class="colGray9">No results</td>
                    </tr>
                  </table>
                </div>
              </el-tab-pane>

            </el-tabs>
          </div>
        </div>
        <div class="l mainRight">
          <h3><span :class="OrderInfo.IsDetention=='1' ? 'colRed marR5' : 'colBlue marR5'">●</span>{{StatusName(OrderInfo.Status)}}</h3>
          <p class="marTop5 marBot10">Detailed trace info.</p>
          <div class="trackInfo">
            <div class="trackImg l">
              <img :src="TrajectoryUrl" width="32">
            </div>
            <div class="trackText l">
              <div :class="IsDeparture2 || IsDeparture ? 'height200' : 'height100'" style="margin-top:5px;">
                <label @click="OpenDeparture()" v-if="OrderInfo.DeliveryType==0||OrderInfo.DeliveryType==1||OrderInfo.DeliveryType==2" style="overflow:hidden;display:block">
                  <b class="l colBlack" style="width:90%">{{OrderInfo.StartCityNameEn}}</b>
                  <i class="fa r fa-arrDown colGray9" style="margin-top:4px;cursor:pointer" :class="IsDeparture2 ? 'tranForm180' : ''"></i>
                </label>
                <label @click="OpenDeparture()" v-if="OrderInfo.DeliveryType==3" style="overflow:hidden;display:block">
                  <b class="l colBlack" style="width:90%">{{OrderInfo.THCityEnName}}</b>
                  <i class="fa r fa-arrDown colGray9" style="margin-top:4px;cursor:pointer" :class="IsDeparture ? 'tranForm180' : ' '"></i>
                </label>
                <table border="0" cellspacing="0" cellpadding="0" width="100%" class="trackTable marTop10" v-if="IsDeparture">
                  <tr>
                    <td width="10%" align="left" class="veTop"><i class="fa fa-houseIcon colGray9" style="font-size:16px;"></i></td>
                    <td v-if="OrderInfo.DeliveryType==3">Your supplier's factory/warehouse</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td v-if="OrderInfo.ThConnect">Order time:{{OrderInfo.ThConnect.CreateTime | dateFmt('HH:mm a, MMM DD, YYYY') }}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td v-if="OrderInfo.ThConnect">Cargo ready:{{OrderInfo.ThConnect.PlanCargoDate| dateFmt('MMM DD, YYYY')}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td v-if="OrderInfo.THInfo.ReceiverTime">Delivered:{{ OrderInfo.THInfo.ReceiverTime| dateFmt('HH:mm a, MMM DD, YYYY')}}</td>
                  </tr>
                </table>
                <table border="0" cellspacing="0" cellpadding="0" width="100%" class="trackTable marTop10" v-if="IsDeparture2">
                  <tr>
                    <td width="10%" align="left" class="veTop"><i class="fa fa-houseIcon colGray9" style="font-size:16px;"></i></td>
                    <td>Your supplier's factory/warehouse</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Order time: {{OrderInfo.CreateTime| dateFmt('HH:mm a, MMM DD, YYYY')}}</td>
                  </tr>
                </table>
              </div>
              <div :class="IsWareHouse ? 'marTop10 height3' : 'marTop10 height2'">
                <label @click="OpenWarehouse()" style="overflow:hidden;display:block">
                  <b class="l colBlack" style="width:90%">{{WarehouseName}} {{WareShortCode?'('+WareShortCode+')':''}}</b>
                  <i class="fa r fa-arrDown colGray9" style="margin-top:4px;cursor:pointer" :class="IsWareHouse ? 'tranForm180' : ''"></i>
                </label>
                <table border="0" cellspacing="0" cellpadding="0" width="100%" class="trackTable marTop10" v-if="IsWareHouse">
                  <tr>
                    <td width="10%" align="left" class="veTop"><i class="fa fa-houseIcon2 colGray9" style="font-size:16px;"></i></td>
                    <td>{{OrderInfo.StartCityNameEn}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td v-if="OrderInfo.InStoreTime">Received:{{OrderInfo.InStoreTime|dateFmt('HH:mm a, MMM DD, YYYY')}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td v-if="OrderInfo.OutStoreTime">Shipped:{{OrderInfo.OutStoreTime|dateFmt('HH:mm a, MMM DD, YYYY')}}</td>
                  </tr>
                </table>
              </div>
              <div class="marTop5">
                <label style="overflow:hidden;display:block;">
                  <b class="l colBlack" style="width:90%">{{OrderInfo.DestCountryNameEn}}</b>
                  <i v-if="IsDestinationxl" @click="OpenDestination()" class="fa r fa-arrDown colGray9" style="margin-top:4px;cursor:pointer" :class="IsDestination ? 'tranForm180' : ' '"></i>
                </label>
                <div class="colGray6 marTop5">
                  <b v-if="OrderInfo.TrackingNO">Tracking No.:{{OrderInfo.TrackingNO}}</b>
                  <b v-if="!OrderInfo.TrackingNO">Tracking No.:No results</b>
                </div>
                <ul class="trackFinal" v-if="IsDestination">
                  <li v-for="item in ExpOrderTrackInfo">
                    <div class="dot colBlue">●</div>
                    <div class="Line">
                      <span v-if="item.TrackTime">{{item.TrackTime| dateFmt('HH:mm a, MMM DD, YYYY')}}</span>
                      <p>[{{item.Position}}]{{item.TrackInfo}}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <!--遮罩层-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { post, fetch, Del, put } from "../../../ask/axios";
import Vue from 'vue'
export default {
  props: {
    IsWhat: {
      type: String
    }
  },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      titNames: '我的订单,快递订单,订单详情',
      titUrls: ',/exp/expEdit,',

      //tab选项卡
      activeName: 'second',

      //订单信息
      OrderInfo: [],
      //订单编号
      OrderId: '',
      //订单仓库编号
      WareHouseID: '',
      //订单保险信息
      OredrInsurance: [],
      //订单收货材积信息
      OrderGoodsInfo: [],
      //订单轨迹信息
      ExpOrderTrackInfo: [],
      //订单附件信息
      OrderEnclosure: [],
      //订单账单信息
      OrderBillInfo: [],
      //仓库地址信息
      shipAddress: '',
      //收货人名称
      recipient: '',
      //收货电话
      phoneNum: '',
      //收货仓库名称
      WarehouseName: '',


      //收货材积
      Receivinginfo: {
        ReceCount: '', //件数
        ReceWeight: '',//实重
        ReceVolume: '',//总体积
        ReceCusVolWeight: '',//体积重
        ReceCusChargeWeight: '', //计费重
      },

      Token: '',


      //是否显示起运地信息
      IsDeparture: false,
      IsDeparture2: false,
      //是否显示仓库信息
      IsWareHouse: false,
      //是否显示目的地信息
      IsDestination: false,
      //是否提供仓库信息下拉
      IsWareHousexl: true,
      //是否提供目的地下拉
      IsDestinationxl: true,
      //附加服务
      ExpOrderExtraFeeName: '',
      WarehouseName: '',
      WareShortCode: '',

      //轨迹图片Url
      TrajectoryUrl: './../../../static/img/Trajectory07.png',
      CustomerID: '',
      CustomerIDUp: '',
      AmountName: '',
      //是否显示参考号添加框
      IsCustomerID: false,
      //是否显示货物详情
      IsOrderEnclosure: false,
      //是否显示仓库信息
      IsWarehouse: false,
      ShowProBox: true,
      isShowProInfo: false,
      ProductList: [], //产品信息列表

    }

  },
  watch: {
    // 监听数据中的 example0
    $route(to, from) {
      this.GetOredrKey(this.$route.query.WaybillNO)
    }

  },
  computed: {
    SumOredrBill() {
      let info = 0;
      this.OrderBillInfo.forEach(e => {
        if (e.BillStatus != 1 && e.Currency == 1) {
          info += e.Amount;
        }
      });
      return info;
    },
    SumOredrBillwb() {
      let info = 0;
      this.OrderBillInfo.forEach(e => {
        if (e.BillStatus != 1 && e.Currency == 2) {
          info += e.ConvertAmount;
        }
      });
      return info;
    },
    SumOredr() {
      let info = 0;
      this.OrderBillInfo.forEach(e => {
        if (e.Currency == 1) {
          info += e.Amount;
        }
      });
      return info;
    },
    SumOredrwb() {
      let info = 0;
      this.OrderBillInfo.forEach(e => {
        if (e.Currency == 2) {
          info += e.ConvertAmount;
        }
      });
      return info;
    },

    SumOredrWeight() {
      let info = 0
      this.OrderGoodsInfo.forEach(e => {
        info += e.Weight * e.Quanlity;
      });
      return info;
    },
    SumOredrVolume() {
      let info = 0
      this.OrderGoodsInfo.forEach(e => {
        info += e.Volume * e.Quanlity;
      });
      return info;
    },
    SumOredrVolWeight() {
      let info = 0
      this.OrderGoodsInfo.forEach(e => {
        info += e.CusVolWeight * e.Quanlity;
      });
      return info;
    },
    SumOredrQuanlity() {
      let info = 0
      this.OrderGoodsInfo.forEach(e => {
        info += e.Quanlity;
      });
      return info;
    },
    SumOredrChargeWeight() {
      let info = 0
      this.OrderGoodsInfo.forEach(e => {
        info += e.CusChargeWeight;
      });
      return info;
    },


  },
  created() {
    //console.log('zheshishenem      '+  this.$refs.GetOrderValue.GetOrderId())
  },

  mounted() {
    //验证调取
    //this.getValidVice();\
    //获取数据
    this.AllGetOrder(this.$route.query.WaybillNO);

  },
  methods: {
    //选项卡
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    AllGetOrder(id) {
      //let id=this.$refs.GetOrderValue.GetOrderId()
      //订单信息
      this.OrderInformation(id);
    },
    //左边菜单栏选择改变事件
    GetOredrKey(id) {
      this.AllGetOrder(id)
    },
    //获取订单信息接口
    OrderInformation(id) {
      let that = this;
      that.api.param = {
      }
      // debugger;
      that.api.url = this.$api03 + "/api/TradeCustomer/OuterExpNewOrder/GetCustOrder/" + id;
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK && res.Results != null) {
          that.OrderInfo = res.Results  //所有订单信息
          that.WareHouseID = res.Results.WareHouseID;

          that.Receivinginfo.ReceCount = res.Results.ReceCount
          that.Receivinginfo.ReceWeight = res.Results.ReceWeight
          that.Receivinginfo.ReceVolume = res.Results.ReceVolume
          that.Receivinginfo.ReceCusVolWeight = res.Results.ReceCusVolWeight
          that.Receivinginfo.ReceCusChargeWeight = res.Results.ReceCusChargeWeight
          //轨迹信息默认展示
          that.StatusShow();
          that.isShowProBox()
          that.ExpOrderInsurance();
          that.ExpOrderGoodsInfo();
          that.getShipAddr();
          that.getExpBill();
          that.ExpOderEnclosure();
          that.ExpOrderTrack();
          that.TokenApi();
        }
      })
    },
    //保险信息接口
    ExpOrderInsurance() {
      let that = this;
      that.api.param = {
        waybillNO: that.OrderInfo.Id
      }
      that.api.url = this.$api03 + "/api/TradeCustomer/OuterExpOrderInsurance/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK && res.Results != null) {
          that.OredrInsurance = res.Results  //订单保险信息
          //console.log('ss'+JSON.stringify(res));
        }
      })
    },
    //获取附加服务
    GetExpOrderExtraFee() {
      let that = this;
      that.api.param = {
        WaybillNO: that.$route.query.ord
      }
      that.api.url = this.$api03 + "/api/TradeCustomer/ExpOrderExtraFee/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK && res.Results != null) {
          res.Results.forEach(e => {
            if (e.RelatedService == 0) {
              that.ExpOrderExtraFeeName += e.FeeName + ',';
            } else {
              if (e.RelatedService == 1) {
                that.ExpOrderExtraFeeName += '一般贸易报关服务' + ',';
              }
              if (e.RelatedService == 2) {
                that.ExpOrderExtraFeeName += '关税预付服务' + ',';
              }
              if (e.RelatedService == 3) {
                that.ExpOrderExtraFeeName += '第三方支付关税服务' + ',';
              }
            }
          })
        }
        //that.api.url=this.$api03+"/api/TradeCustomer/ExpOrderExtraFee/Get";
        that.api.url = this.$api04 + "/Express/api/ExpOrderExtraFee/Get";
        fetch(that.api.url, that.api.param).then(function (res) {
          if (res.IsOK && res.Results != null) {
            res.Results.forEach(e => {
              if (e.RelatedService == 0) {
                that.ExpOrderExtraFeeName += e.FeeName + ',';
              } else {
                if (e.RelatedService == 1) {
                  that.ExpOrderExtraFeeName += '一般贸易报关服务' + ',';
                }
                if (e.RelatedService == 2) {
                  that.ExpOrderExtraFeeName += '关税预付服务' + ',';
                }
                if (e.RelatedService == 3) {
                  that.ExpOrderExtraFeeName += '第三方支付关税服务' + ',';
                }
              }
            })
          }

        })
      })
    },
    //货物信息接口
    ExpOrderGoodsInfo() {
      let that = this;
      that.api.param = {
        waybillNO: that.OrderInfo.Id
      }
      that.api.url = this.$api03 + "/api/TradeCustomer/OuterExpOrder/QueryExpOrderReceVolume";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true && res.Results != null) {
          that.OrderGoodsInfo = res.Results  //订单收货材积信息
          //console.log('ss'+JSON.stringify(res));
        }
      })
    },
    getShipAddr() {
      let that = this;
      that.api.url = that.$api04 + "/Air/api/SupplierWarehouse/GetWarhouseByID?id=" + that.WareHouseID;
      fetch(that.api.url).then(function (res) {
        if (res.IsOK == true) {
          //console.log(res)
          that.shipAddress = res.Results.ProvinceName + res.Results.CityName + res.Results.CityAreaName + res.Results.WareAddress;
          that.recipient = res.Results.PersonCharge;
          that.phoneNum = res.Results.PersonPhone;
          that.WarehouseName = res.Results.WareAutoCodeEn;
          that.WareShortCode = res.Results.WareShortCode;
        }
      })
    },





    //获取订单账单信息
    getExpBill() {
      let that = this;
      that.api.param = {
        waybillNO: that.OrderInfo.Id
      }
      that.api.url = that.$api03 + "/api/TradeCustomer/OuterExpBill/QueryExpCusFeeBill";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.OrderBillInfo = res.Results;
        }
      })
    },
    //是否显示产品信息
    isShowProBox() {  //运输方式为FEDEX、UPS、TNT的订单详情展示产品信息模块
      let obj = 'FEDEX,UPS,TNT'
      this.OrderInfo.BaseModeCode = 'FEDEX'
      if (obj.indexOf(this.OrderInfo.BaseModeCode) > -1) {
        this.getProductInfoApi()
      } else {
        this.ShowProBox = false
      }
    },
    //订单附件信息
    ExpOderEnclosure() {
      let that = this;
      that.api.param = {
        waybillNO: that.OrderInfo.Id
      }
      that.api.url = that.$api03 + "/api/TradeCustomer/OuterExpOrderUploadFiles/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.OrderEnclosure = res.Results  //订单附件信息
          //console.log('ss'+JSON.stringify(res));
        }
      })
    },
    //获取轨迹信息
    ExpOrderTrack() {
      let that = this;
      that.api.param = {
        waybillNO: that.OrderInfo.Id
      }
      that.api.url = this.$api03 + "/api/TradeCustomer/OuterExpOrderTrack/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true && res.Results != null) {
          //轨迹信息获取
          that.ExpOrderTrackInfo = res.Results;
        }
        that.api.url = this.$api03 + "/api/TradeCustomer/OuterExpOrderTrack/Get";
        fetch(that.api.url, that.api.param).then(function (res) {
          if (res.IsOK == true && res.Results != null) {
            //轨迹信息获取
            that.ExpOrderTrackInfo = res.Results;
          }
        })
      })
    },
    //下载附件信息
    DownloadAttachments(id) {
      let that = this;
      that.$confirm("是否下载附件！", "提示", {
        customClass: "custom-message-box", //自定义添加Class
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        // showCancelButton: false, //去掉取消按钮
        // showClose: false, //去掉右上角的取消（X）
        //  type: 'warning',
        center: true
      })
        .then(() => {
          var newWin = window.open();
          newWin.location.href = that.$api03 + id;
        })
        .catch(() => { });
      return false;
    },
    //产品信息接口
    getProductInfoApi() {
      let that = this;
      //that.api.url=that.$api03+"/api/TradeCustomer/ExpOrderProduct/Get?waybillNO="+that.$route.query.WaybillNO;
      that.api.url = that.$api04 + "/Express/api/ExpOrderProduct/Get?waybillNO=" + that.$route.query.WaybillNO;
      fetch(that.api.url).then(function (res) {
        if (res.IsOK && res.Results.length > 0) {
          that.ProductList = res.Results
        }
      })
        .catch(() => { });
      return false;
    },
    //产品信息接口
    getProductInfoApi() {
      let that = this;
      that.api.url = that.$api03 + "/api/TradeCustomer/ExpOrderProduct/Get?waybillNO=" + that.$route.query.WaybillNO;
      fetch(that.api.url).then(function (res) {
        if (res.IsOK && res.Results.length > 0) {
          that.ProductList = res.Results
        }
      })
    },

    //打开货物详情
    SelectDetailed() {

      if (this.IsOrderEnclosure) {
        this.IsOrderEnclosure = false;
      } else {
        this.ExpOrderGoodsInfo();
        this.IsOrderEnclosure = true;
      }
    },
    //打开仓库信息
    Warehouse() {

      if (this.IsWarehouse) {
        this.IsWarehouse = false;
      } else {
        this.IsWarehouse = true;
      }
    },
    //打开起运地信息
    OpenDeparture() {
      if (!this.IsDeparture && this.OrderInfo.DeliveryType == 3) {
        this.IsDeparture = true;
        this.IsWareHouse = false;
        this.IsDestination = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.5.png';
        }

      } else if (!this.IsDeparture2 && (this.OrderInfo.DeliveryType == 0 || this.OrderInfo.DeliveryType == 1 || this.OrderInfo.DeliveryType == 2)) {
        this.IsDeparture2 = true;
        this.IsWareHouse = false;
        this.IsDestination = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.5.png';
        }

      } else if (this.IsDeparture && this.OrderInfo.DeliveryType == 3) {
        this.IsDeparture = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.5.png';
        }
      }
      else if (this.IsDeparture2 && (this.OrderInfo.DeliveryType == 0 || this.OrderInfo.DeliveryType == 1 || this.OrderInfo.DeliveryType == 2)) {
        this.IsDeparture2 = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.5.png';
        }
      }


    },
    //打开仓库信息
    OpenWarehouse() {
      if (this.IsWareHouse) {
        this.IsWareHouse = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.5.png';
        }
      } else {
        this.IsWareHouse = true;
        this.IsDeparture = false;
        this.IsDeparture2 = false;
        this.IsDestination = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.5.png';
        }
      }
    },
    //打开目的地信息
    OpenDestination() {
      if (this.IsDestination) {
        this.IsDestination = false;
      } else {
        this.IsDestination = true;
        this.IsWareHouse = false;
        this.IsDeparture = false;
        this.IsDeparture2 = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.5.png';
        }


      }
    },
    //时间格式转换
    BillStatusName(id) {
      if (id == 0) return 'Unfinished';
      if (id == 1) return 'Finished';
      if (id == 2) return 'Unfinished';
    },
    ExportBill() {
      let that = this;
      that.api.param = {
        WaybillNO: that.OrderInfo.Id
      }
      that.api.url = that.$api03 + "/api/TradeCustomer/OuterExpOrder/BillCostReportQuery";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a');
          eleLink.download = "";
          eleLink.style.display = 'none';
          // 字符内容转变成blob地址
          //                var blob = new Blob([content]);
          eleLink.href = that.$api03 + '/' + res.Results, '_blank';
          // 触发点击
          document.body.appendChild(eleLink);
          eleLink.click();
          // 然后移除
          document.body.removeChild(eleLink);
        }
      })

    },
    //获取订单状态名称
    StatusName(code) {
      if (code == "0") return "Confirming";
      if (code == "1") return "Receiving";
      if (code == "2") return "Received";
      if (code == "3") return "Delivered";
      if (code == "4") return "Completed";
      if (code == "5") return "Returned";
      if (code == "6") return "Canceled";

    },
    ///我的消息
    SrcFrom(id) {
      var imtoken = $.cookie('IMEn-TOKEN');
      //console.log(this.$apiIMEn,"this.$apiIMEn")
      return this.$apiIMEn + 'chats/Worklist?orderid=' + id + '&trackid=' + imtoken + '&lan=English';
    },
    //获取ToKEn
    TokenApi() {
      let that = this;
      that.api.param = {
        "userName": that.$route.query.content,
        "passWord": "echo001—CUS",
        "roleName": "收货人",
        "realName": "收货人",
        "corporateName": "收货人公司"
      }
      that.api.url = this.$api03 + "/api/TradeCustomer/OuterOrderOnlineInfo/IMToken";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.Token = res.Results.token;
        }
      })
    },
    //轨迹显示状态
    StatusShow() {
      if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
        this.IsDeparture2 = true;
        this.IsDestinationxl = false;

        this.TrajectoryUrl = '../../../static/img/Trajectory08.png';
        //默认展开第一段，仅显示下单时间；第二段默认不展开；第三段不提供展开收起图标。
      }
      if (this.OrderInfo.Status == 1 && this.OrderInfo.DeliveryType == 0) {
        this.IsDeparture2 = true;
        //点亮第一段和货车连接线；默认展开第一段；第二段默认不展开，第三段默认不展开
        this.TrajectoryUrl = '../../../static/img/Trajectory03.png';
      }
      if (this.OrderInfo.Status == 1 && (this.OrderInfo.DeliveryType == 2 || this.OrderInfo.DeliveryType == 3)) {
        this.IsDeparture = true;
        this.TrajectoryUrl = '../../../../static/img/Trajectory03.png';
        //点亮第一段和货车连接线；默认展开第一段；第二段默认不展开，第三段默认不展开
      }
      if (this.OrderInfo.Status == 2) {
        this.IsWareHouse = true;
        this.TrajectoryUrl = '../../../../static/img/Trajectory07.png';
        //点亮起始城市、货车连接路线、收货仓库；第一段默认不展开，默认展开第二段，第三段默认不展开
      }
      if (this.OrderInfo.Status == 3) {
        this.IsDestination = true;
        this.TrajectoryUrl = '../../../../static/img/Trajectory09.png';
        //点亮起始城市、货车连接路线、收货仓库、飞机连接路线；第一段和第二段默认不展开，默认展开第三段。其中，订单承运商的轨迹，最新的一条用蓝色圆圈标识。
      }
      if (this.OrderInfo.Status == 4) {
        this.IsDestination = true;
        //全部点亮；第一段和第二段默认不展开，默认展开第三段
        this.TrajectoryUrl = '../../../../static/img/Trajectory10.png';
      }
    },
    AmountNameGet(id) {
      if (id == 1) {
        this.AmountName = '￥';
      }
      if (id == 2) {
        this.AmountName = '$';
      }
    },
    PackageTypeName(id) {
      if (id == 1) return 'Package';
      if (id == 2) return 'Docs';
    },
    InsideBatteryName(code) {
      if (code == 10)
        return 'Built-in lithium ion batteries'
      if (code == 11)
        return 'Built-in lithium metal batteries'
    },
    MatingBatteryName(code) {
      if (code == 17)
        return 'Dry batteries packed with equipment'
      if (code == 18)
        return 'Lithium ion batteries packed with equipment'
      if (code == 19)
        return 'Lithium metal batteries packed with equipment'
    },
    //点击产品信息查看明细按钮
    clkProInfos() {
      this.isShowProInfo = !this.isShowProInfo
    },
  }
}
</script>
<style type="text/css" rel="stylesheet" scoped="scoped">
@import "../../../assets/css/details.css";
.mainContent {
  float: left;
  width: 100%;
  height: 100%;
}
.main {
  height: 100%;
  width: 100%;
}
.marL {
  margin-left: 200px !important;
  margin-right: 10px !important;
  margin-top: 75px;
}
.height200 {
  height: 105px;
}
.height100 {
  height: 60px;
}
.height2 {
  height: 50px;
}
.height3 {
  height: 104px;
}
.tableGrayBotLine tr th,
.tableGrayBotLine tr td {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/receiptPage/exp/receiptExpDetails.vue